var axios = require('axios')
var url = process.env.prefix_banner_be + '/banner'
var urlposition = process.env.prefix_banner_be + '/position'

axios.getBannerList = function (params, cancel, success, callBackError) {
  this.get(url + '/list?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getBannerDetail = function (params, success, callBackError) {
  this.get(url + '/' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getPositionList = function (success, callBackError) {
  this.get(urlposition + '/list')
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.createBanner = function (params, success, callBackError) {
  this.post(url + '/create', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.updateBanner = function (params, success, callBackError) {
  this.put(url + '/' + params.uuid, params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.uploadBannerImages = function (params, configs, success, callBackError) {
  this.post(url + '/upload-image', params, configs)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.updateBannerStatus = function (params, success, callBackError) {
  this.post(url + '/banner-status', params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

export default axios



// WEBPACK FOOTER //
// ./src/assets/api/Banner.js